(function () {
  if (!window.matchMedia('(min-width: 768px) and (hover: hover)').matches) return;

  document.addEventListener('DOMContentLoaded', function () {
    var product = document.querySelector('.product.office-chair-smile-layout');
    var form = product && product.querySelector('.product-single__meta form.product-form');
    if (!form) return;

    var checkbox = form.querySelector('.smile-pro-addon__checkbox');
    var card = form.querySelector('.smile-pro-addon__card');
    var price = form.querySelector('[data-smile-addon-price]');

    form.querySelectorAll('[data-smile-addon-variant]').forEach(function (swatch) {
      swatch.addEventListener('click', function () {
        if (!checkbox) return;

        form.querySelectorAll('[data-smile-addon-variant]').forEach(function (option) {
          var selected = option === swatch;
          option.classList.toggle('is-active', selected);
          option.setAttribute('aria-pressed', selected ? 'true' : 'false');
        });

        checkbox.dataset.id = swatch.dataset.smileAddonVariant;
        checkbox.disabled = swatch.dataset.smileAddonAvailable !== 'true';
        if (checkbox.disabled) checkbox.checked = false;
        if (price) price.textContent = swatch.dataset.smileAddonPrice;
        if (card) card.classList.toggle('is-selected', checkbox.checked);
      });
    });

    if (checkbox) {
      checkbox.addEventListener('change', function () {
        if (card) card.classList.toggle('is-selected', checkbox.checked);
      });
    }
  });
})();
